const config = {
  // workersUrl: "https://workers.mdanics.workers.dev",
  workersUrl: "http://127.0.0.1:8787",
};

export { config };
